import { TextField, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { useOperationsStore } from '@operations/AppProvider'
import { convertOperationType } from '@operations/utils/helper'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { formatDateRange } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { WorkQueueRenameModel } from '../../models/work-instruction-view.model'

interface Props {
  isOpen: boolean
  queue?: WorkQueueRenameModel
  handleClose: () => void
  handleSubmit: (id: number, name?: string) => Promise<void>
}
export const NameWorkQueueDialogContainer = observer(
  ({ isOpen, queue, handleClose, handleSubmit }: Props) => {
    const { t } = useTranslate()
    const { appStore } = useOperationsStore()

    const [workQueueName, setWorkQueueName] = useState(queue?.name ?? '')

    useEffect(() => {
      setWorkQueueName(queue?.name ?? '')
    }, [queue, queue?.name])

    if (!queue) {
      return null
    }

    const onSubmit = async () => {
      handleClose()
      try {
        if (workQueueName !== queue?.name) {
          await handleSubmit(
            queue?.id as number,
            workQueueName.trim() === '' ? undefined : workQueueName,
          )
        }
        appStore.setShowAlert('success', t('workQueueNameUpdated', 'Work queue name updated'))
      } catch (error) {
        appStore.setShowAlert(
          'error',
          t('errorUpdatingWorkQueueName', 'Error updating work queue name'),
        )
      }
    }

    return (
      <ConfirmationDialog
        open={isOpen}
        title={
          queue.name
            ? t('editTheNameForTheWorkQueue', 'Edit the Name for the Work queue')
            : t('createANameForTheWorkQueue', 'Create a Name for the Work queue')
        }
        primaryActionText={queue.name ? t('yesEdit', 'Yes, edit') : t('yesCreate', 'Yes, create')}
        closeLabel={t('noCancel', 'No, cancel')}
        onClose={handleClose} //() => store.setIsNameWorkQueueDialogOpen(false)}
        onConfirm={onSubmit}
      >
        <Stack
          gap={2}
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant='subtitle2' color='secondary'>
            {queue.name
              ? t(
                  'pleaseEditTheNameForTheCurrentWorkQueue',
                  'Please edit the name for the current work queue:',
                )
              : t(
                  'pleaseCreateANameForTheCurrentWorkQueue',
                  'Please create a name for the current work queue:',
                )}
          </Typography>
          <Stack flexDirection='column'>
            <Typography variant='subtitle2'>{`${t(convertOperationType(queue.operationType))} ${t('bay', 'Bay')} ${queue.bay} - ${queue.vesselArea}`}</Typography>
            <Typography variant='caption' color='secondary'>
              {formatDateRange(queue.startTime, queue.endTime)}
            </Typography>
          </Stack>
          <TextField
            label={t('name', 'Name')}
            onChange={e => setWorkQueueName(e.target.value)}
            value={workQueueName}
            fullWidth
          />
        </Stack>
      </ConfirmationDialog>
    )
  },
)
